<template>
  <div class="pro-main">
    <ul class="pro-list" @scroll="activityScroll">
        <li v-for="item in list" :key="item.id">
            <img class="img" :src="cdnUrl + JSON.parse(item.img_url)[0]">
            <div class="content">
                <p class="two">{{ item.title }}</p>
                <div class="btn" @click="handleDetail(item.id)">查看详情</div>
            </div>
        </li>
    </ul>
    <footerLine></footerLine>
  </div>
</template>

<script>
import { getCenProgramme } from '@/api/centrifuge'
import footerLine from '@/components/footerLine'
export default {
    components: {
        footerLine
    },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            page: 1,
            pageSize: 10,
            list: []
        }
    },
    created () {
        this.getProList()
    },
    mounted() {
      document.title = this.$route.query.centrifugeType == 1 ? "离心方案" : "应用案例列表";
    },
    methods: {
        async getProList() {
            let para = {
                page: this.page,
                pageSize: this.pageSize,
                type: 3,
                mark: this.$route.query.centrifugeType
            }
            let data = await getCenProgramme(para)
            this.list.push(...data.data.data)
            this.last_page = data.data.last_page
        },
        handleDetail(id) {
            this.$router.push({
                name: 'programmeDetail',
                query: {
                    id
                }
            })
        },
        activityScroll () {
            // console.log('查看');
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 5 // 距离底部距离
            this.scrollTop = scrollTop
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.page < this.last_page) {
                    this.page++
                    this.getProList()
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.pro-main {
    padding: 0 rem(16);
}
    .pro-list {
        display: flex;
        flex-wrap: wrap;
        li {
            width: 100%;
            height: rem(86);
            margin-top: rem(16);
            display: flex;
            justify-content: space-between;
            .img {
                width: rem(130);
                height: rem(86);
                border-radius: rem(4);
                margin-right: rem(10);
                flex-shrink: 0;
                flex-basis: rem(130);
            }
            .content {
                flex: 1;
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-end;
                p {
                    width: 100%;
                    height: rem(40);
                    color: #333;
                    font-size: rem(16);
                }
                
                .btn {
                    width: rem(76);
                    height: rem(28);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 4px;
                    border: 1px solid #59C1D6;
                    font-weight: 400;
                    font-size: 14px;
                    color: #59C1D6;
                    margin-top: rem(10);
                }
            }
        }
    }
    
</style>